import HTTP from '@/plugins/http';

const withdrawBankApi = {
  page: '/withdrawBank/list/page',
  add: '/withdrawBank/add',
  del: '/withdrawBank/delete',
  update: '/withdrawBank/update',
  export: '/withdrawBank/export',
  bankcodeList: '/admin/getBankCodeList',
};

function getPage({ data, params }) {
  return HTTP({
    url: withdrawBankApi.page,
    method: 'post',
    data: { query: data, ...params }
  });
}
function doAdd(data) {
  return HTTP({
    url: withdrawBankApi.add,
    method: 'post',
    data
  });
}
function doDel(data) {
  return HTTP({
    url: withdrawBankApi.del,
    method: 'post',
    data
  });
}
function doUpdate(data) {
  return HTTP({
    url: withdrawBankApi.update,
    method: 'post',
    data
  });
}
function doExport(data) {
  return HTTP.loading({
    url: withdrawBankApi.export,
    method: 'post',
    data
  });
}

function getBankCodeList() {
  return HTTP({
    url: withdrawBankApi.bankcodeList,
    method: 'get',
  });
}

export default { getPage, doAdd, doDel, doUpdate, doExport,getBankCodeList };



// WEBPACK FOOTER //
// ./src/api/withdrawBank.js